import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { IRegisterNewCompanyParams } from 'types/Company.types';
import { registerNewCompany } from 'services/CompanyService';
import {
  clearActivationToken,
  isActivationSessionEnded,
} from 'services/ActivationTokenService';

// onSessionEnded: the link's session ended (a 401); the page sends the contact
// back to sign in on the link.
export const useRegisterCompany = (onSessionEnded: () => void) =>
  useMutation(
    (params: IRegisterNewCompanyParams) => registerNewCompany(params),
    {
      onSuccess: () => {
        clearActivationToken();
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error));
        if (isActivationSessionEnded(error)) {
          onSessionEnded();
        }
      },
      mutationKey: ReactMutationKeys.REGISTER_NEW_COMPANY,
    }
  );
